import { component } from 'picoapp';
import { gsap } from 'gsap';

export default component((node) => {
  const PACK_SIZE = 4; // No. of items

  let $addButtons, $subtractButtons, remaining, $qtyInput, $lineItem;
  
  const storeDescriptionHeights = () => {
    const descriptions = node.querySelectorAll('.js-product-description');

    descriptions.forEach(description => {
      description.dataset.height = description.getBoundingClientRect().height;
      gsap.set(description, { height: 0 });
    });

    gsap.fromTo(node, { autoAlpha: 0 }, { autoAlpha: 1 });
  };

  const setReferenceElements = () => {
    $addButtons = $(node).find('.js-quantity-add');
    $subtractButtons = $(node).find('.js-quantity-remove');
    $qtyInput = $(node).find('.js-quantity-input');
    $lineItem = $(node).find('.js-line-item');
  };

  const addEventListeners = () => {
    $addButtons.click(addToQty);
    $subtractButtons.click(subtractFromQty);
    $qtyInput.change(handleInput);
    $lineItem.on('click', '.js-toggle-product-description', toggleDescription);
  };

  const hideDescription = (lineItem) => {
    const description = lineItem.querySelector('.js-product-description');
    const tl = gsap.timeline();
    tl.to(description, { autoAlpha: 0, duration: 0.3 })
      .to(description, {
        height: 0,
        duration: 0.3,
        ease: 'power3.out'
      }, '-=0.1');
    lineItem.removeAttribute('data-expanded');
  };

  const showDescription = (lineItem) => {
    const description = lineItem.querySelector('.js-product-description');
    const tl = gsap.timeline();
    tl.to(description, {
      height: description.dataset.height,
      duration: 0.3,
      ease: 'power3.out'
    });
    tl.to(description, { autoAlpha: 1, duration: 0.3 }, '-=0.1');
    lineItem.setAttribute('data-expanded', true);
  };

  const toggleDescription = function (e) {
    const lineItem = e.delegateTarget;
    const isExpanded = lineItem.getAttribute('data-expanded');
    isExpanded
      ? hideDescription(lineItem)
      : showDescription(lineItem);
  };

  const enableQtyButtons = (type) => {
    $(`.js-quantity-${type}`)
      .removeClass('is-disabled')
      .removeAttr('disabled');
  };

  const disableQtyButtons = (type) => {
    $(`.js-quantity-${type}`)
      .addClass('is-disabled')
      .attr('disabled', true);
  };

  const addToQty = (e) => {
    const button = e.currentTarget;
    const input = $(button).siblings('.js-quantity-input');
    const currentValue = parseInt(input.val());
    input.val(isNaN(currentValue) ? 1 : currentValue + 1);
    input.trigger('change');
  };

  const subtractFromQty = (e) => {
    const button = e.currentTarget;
    const input = $(button).siblings('.js-quantity-input');
    const currentValue = parseInt(input.val());
    input.val(isNaN(currentValue) ? 0 : currentValue - 1);
    input.trigger('change');
  };

  const disableLineButton = (element, type) => {
    $(element).siblings(`.js-quantity-${type}`)
      .addClass('is-disabled')
      .attr('disabled', true);
  };

  const enableLineButton = (element, type) => {
    $(element).siblings(`.js-quantity-${type}`)
      .removeClass('is-disabled')
      .removeAttr('disabled');
  };

  const disableAddToCartButton = () => {
    $('.js-add-to-cart')
      .addClass('is-disabled')
      .attr('disabled', true);
  };

  const handleInput = (e) => {
    const input = e.currentTarget;
    input.value == 0 
      ? disableLineButton(input, 'remove')
      : enableLineButton(input, 'remove');

    calculateRemaining();
  };

  const enableAddToCartButton = () => {
    $('.js-add-to-cart')
      .removeClass('is-disabled')
      .removeAttr('disabled');
  };

  const init = () => {
    setReferenceElements();
    storeDescriptionHeights();
    addEventListeners();
    disableAddToCartButton();
  };

  const calculateRemaining = () => {
    let newCount = 0;

    // Add up values
    $('.c-mix-and-match__qty-input.js-quantity-input').each((index, input) => {
      const qty = parseInt(input.value);
      newCount += isNaN(qty) ? 0 : qty;
    });

    remaining = PACK_SIZE - newCount;

    // Check against selected quantity
    if (remaining == 0) {
      enableAddToCartButton();
      disableQtyButtons('add');
      updateHelpText('Done!');

    } else if (remaining == 1) {
      disableAddToCartButton();
      enableQtyButtons('add');
      updateHelpText();

    } else if (remaining < 0) {
      disableAddToCartButton();
      updateHelpText();

    } else {
      enableQtyButtons('add');
      disableAddToCartButton();
      updateHelpText();
    }

  };

  const updateHelpText = (newText = null) => {
    const defaultText = 'Select any <span class="c-mix-and-match__limit js-help-qty">4</span>';

    if (newText) {
      $('.js-help-text').text(newText);
    } else {
      $('.js-help-text').html(defaultText);
      $('.js-help-qty').text(remaining);
    }
  };

  init();

});
